import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxACGxLanguageSchema(),
          apiClient.catCognitLangDimCond(),
          apiClient.catCognitLangCond(),
          apiClient.catCognitIntelligence(),
          apiClient.catLevelProof(),
        ]);
        const [schemaRes, catCognitLangDimCond, catCognitLangCond, catIntelligence, catLevelProof] =
          responses.map((res) => res?.data ?? {});

        let id1 = 'A';
        const resCat1 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionA = resCat1.data.data;

        let id2 = 'C';
        const resCat2 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionC = resCat2.data.data;

        let id3 = 'D';
        const resCat3 = await apiClient.catLevelDescription(id3);
        const catLevelDescriptionD = resCat3.data.data;

        let id4 = 'E';
        const resCat4 = await apiClient.catLevelDescription(id4);
        const catLevelDescriptionE = resCat4.data.data;

        let id5 = 'J';
        const resCat5 = await apiClient.catLevelDescription(id5);
        const catLevelDescriptionJ = resCat5.data.data;

        const cognitLangDimCond = catCognitLangDimCond.data ?? [];
        const catCurso = cognitLangDimCond.catCurso;
        const catContenido = cognitLangDimCond.catContenido;
        const catProsodiaE = cognitLangDimCond.catProsodiaE;
        const catProsodiaL = cognitLangDimCond.catProsodiaL;
        const catPronunciacion = cognitLangDimCond.catPronunciacion;
        const catMimica = cognitLangDimCond.catMimica;
        const catLectura = cognitLangDimCond.catLectura;
        const catEscritura = cognitLangDimCond.catEscritura;
        const catOrtografia = cognitLangDimCond.catOrtografia;
        const catCalculo = cognitLangDimCond.catCalculo;

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');
        let schema = structuredClone(schemaRes);
        schema.schemaFormItems[0].schemaForm.group1.schema.i1_cognitive_language_level_description_id.items =
          catLevelDescriptionA;
        schema.schemaFormItems[0].schemaForm.group1.schema.i1_cognitive_language_condition_id.items =
          catCurso;
        schema.schemaFormItems[0].schemaForm.group1.schema.i3_cognitive_language_condition_id.items =
          catContenido;
        schema.schemaFormItems[0].schemaForm.group1.schema.i4_cognitive_language_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[0].schemaForm.group2.schema.i5_cognitive_language_level_description_id.items =
          catLevelDescriptionE;
        schema.schemaFormItems[0].schemaForm.group2.schema.i5_cognitive_language_condition_id.items =
          catProsodiaE;
        schema.schemaFormItems[0].schemaForm.group2.schema.i6_cognitive_language_level_description_id.items =
          catLevelDescriptionE;
        schema.schemaFormItems[0].schemaForm.group2.schema.i6_cognitive_language_condition_id.items =
          catProsodiaL;
        schema.schemaFormItems[0].schemaForm.group2.schema.i7_cognitive_language_condition_id.items =
          catPronunciacion;
        schema.schemaFormItems[0].schemaForm.group2.schema.i8_cognitive_language_level_description_id.items =
          catLevelDescriptionE;
        schema.schemaFormItems[0].schemaForm.group2.schema.i8_cognitive_language_condition_id.items =
          catMimica;
        schema.schemaFormItems[1].schemaForm.group1.schema.i9_cognitive_language_level_description_id.items =
          catLevelDescriptionJ;
        schema.schemaFormItems[1].schemaForm.group1.schema.i10_cognitive_language_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[1].schemaForm.group1.schema.i10_cognitive_language_condition_id.items =
          catLectura;
        schema.schemaFormItems[1].schemaForm.group1.schema.i11_cognitive_language_level_description_id.items =
          catLevelDescriptionJ;
        schema.schemaFormItems[1].schemaForm.group2.schema.i12_cognitive_language_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[1].schemaForm.group2.schema.i12_cognitive_language_condition_id.items =
          catEscritura;
        schema.schemaFormItems[1].schemaForm.group2.schema.i13_cognitive_language_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[1].schemaForm.group2.schema.i13_cognitive_language_condition_id.items =
          catOrtografia;
        schema.schemaFormItems[1].schemaForm.group2.schema.i14_cognitive_language_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[1].schemaForm.group2.schema.i14_cognitive_language_condition_id.items =
          catCalculo;
        schema.schemaFormItems[1].schemaForm.group3.schema.i1_cognitive_language_general_condition_id.items =
          catCognitLangCond.data ?? [];
        schema.schemaFormItems[1].schemaForm.group3.schema.i1_cognitive_intelligence_level_description_id.items =
          catIntelligence.data ?? [];
        schema.schemaFormItems[1].schemaForm.group3.schema.i1_cognitive_intelligence_proof.items =
          catLevelProof.data ?? [];

        const modelFormItems = [
          { modelForm: { group1: {}, group2: {} } },
          { modelForm: { group1: {}, group2: {} } },
        ];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxACGxLanguage(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        if (recordsData.isNewRecord === true) {
          modelSlides.cognitive_aspect_id = dataModelFormItems[0].modelForm.cognitive_aspect_id;
        }

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxACGxLanguage(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = preparedModel.modelSlides.cognitiveAspectId;
        await apiClient.updateCAxACGxLanguage(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
